module.exports = __webpack_public_path__ + "media/ru-adb3d2b4.mp4";